export const PCPROID =  'planogram-check-project-id';
export const PCLAYOUTID =  'planogram-check-layout-id';
export const PCPSTEP =  'planogram-check-step';
export const PCROWCOL =  'planogram-check-row-col';
export const PCIMGARY =  'planogram-check-img-ary';

export const PCISFIRST =  'planogram-check-is-first';
